import React from 'react';
import AboutBanner from '../components/AboutBanner';
import MissionVisionImage from '../images/mission-vision.jpg';
import CustomisedSolutionsIcon from '../images/Customised Solutions.svg';
import CompetitiveInterestRatesIcon from '../images/Competitive Interest Rates.png';
import QuickEasyProcessingIcon from '../images/Quick and Easy Processing.png';
import CustomerSupportIcon from '../images/Customer Support.svg';
import TransparencyIcon from '../images/Transparency.svg';
import CustomerCentricIcon from '../images/Customer-centric Approach.svg';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      <AboutBanner />

      {/* Company Profile Section */}
      <section className="company-profile">
        <div className="container">
          <div className="profile-content">
            <div className="profile-header">
              <h3 className="profile-label">WHO WE ARE</h3>
              <h2 className="profile-title">COMPANY PROFILE</h2>
            </div>
            <div className="profile-text">
              <p>
                At Ampire Finance, we believe in making dreams come true by providing finance solutions to meet your immediate financial needs. Our range of loans includes personal loans, business loans, loan against property, loan against shares, used vehicle loans and invoice discounting.
              </p>
              <p>
                We offer a fast and easy online application process, with a dedicated team of financial professionals to guide you through every step. Our competitive interest rates and flexible repayment options make us the preferred choice for borrowers across India.
              </p>
              <p>
                With our presence in multiple states across India, we are committed to expanding our operations and providing exceptional service to meet the diverse financial needs of our customers. Whether you're planning a dream vacation, starting a new business, or facing an unexpected expense, Ampire Finance is here to help.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Vision Mission Values Section */}
      <section className="vision-mission-values" style={{ backgroundImage: `url(${MissionVisionImage})` }}>
        <div className="vmv-overlay"></div>
        <div className="vmv-container">
          <div className="vmv-header">
            <h3 className="vmv-label">WHO WE ARE</h3>
            <h2 className="vmv-title">ABOUT OUR ORGANIZATION</h2>
          </div>
          
          <div className="vmv-content-wrapper">
            {/* Vision Card */}
            <div className="vmv-card-modern">
              <div className="vmv-card-header">
                <div className="vmv-icon-modern">
                  <span className="icon-target">🎯</span>
                </div>
                <h3 className="vmv-card-title-modern">OUR VISION</h3>
              </div>
              <p className="vmv-description-modern">
                Our Vision is to become a leading provider of loan solutions that allows individuals and businesses to achieve financial freedom. We aim to be known for our customer-centric approach, innovation and transparency.
              </p>
            </div>
            
            {/* Mission Card */}
            <div className="vmv-card-modern">
              <div className="vmv-card-header">
                <div className="vmv-icon-modern">
                  <span className="icon-trophy">🏆</span>
                </div>
                <h3 className="vmv-card-title-modern">OUR MISSION</h3>
              </div>
              <p className="vmv-description-modern">
                At Ampire Finance, our mission is to be the preferred provider of financial products to people in need of it. We aim at delivering best quality services to the clients and make a positive impact in the lives of people by providing them financial support.
              </p>
            </div>
            
            {/* Values Card */}
            <div className="vmv-card-modern vmv-values-card-modern">
              <div className="vmv-card-header">
                <div className="vmv-icon-modern">
                  <span className="icon-chart">📈</span>
                </div>
                <h3 className="vmv-card-title-modern">OUR VALUES</h3>
              </div>
              <div className="values-grid-modern">
                <div className="value-item-modern">
                  <h4 className="value-title-modern">Integrity</h4>
                  <p className="value-description-modern">We are transparent and honest in all our financial services, so you get the best without hidden charges.</p>
                </div>
                <div className="value-item-modern">
                  <h4 className="value-title-modern">Customer-focus</h4>
                  <p className="value-description-modern">Customers come first for us. We believe in delivering personalized support to help you achieve financial success</p>
                </div>
                <div className="value-item-modern">
                  <h4 className="value-title-modern">Excellence</h4>
                  <p className="value-description-modern">We consistently strive for high standards, offering timely, reliable, and innovative financial solutions.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-choose-section">
        <div className="container">
          <div className="why-choose-header">
            <h3 className="why-choose-subtitle">WE ARE ALWAYS FOCUSED ON GROWTH OF CLIENTS</h3>
            <h2 className="why-choose-title">WHY CHOOSE AMPIRE FINANCE?</h2>
            <div className="title-underline"></div>
          </div>
          
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <img src={CustomisedSolutionsIcon} alt="Customised Solutions" />
              </div>
              <h3 className="feature-title">CUSTOMISED SOLUTIONS</h3>
              <p className="feature-description">Our loan products are customised to meet the financial requirements of our customers.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <img src={CompetitiveInterestRatesIcon} alt="Competitive Interest Rates" />
              </div>
              <h3 className="feature-title">COMPETITIVE INTEREST RATES</h3>
              <p className="feature-description">Our interest rates are competitive ensuring your financial commitments are affordable and manageable.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <img src={QuickEasyProcessingIcon} alt="Quick and Easy Processing" />
              </div>
              <h3 className="feature-title">QUICK AND EASY PROCESSING</h3>
              <p className="feature-description">You can get loans approved faster and with minimal paperwork.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <img src={CustomerSupportIcon} alt="Customer Support" />
              </div>
              <h3 className="feature-title">CUSTOMER SUPPORT</h3>
              <p className="feature-description">You will be guided by our financial experts throughout the entire process.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <img src={TransparencyIcon} alt="Transparency" />
              </div>
              <h3 className="feature-title">TRANSPARENCY</h3>
              <p className="feature-description">We have an open system with straightforward processes and with no hidden charges.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <img src={CustomerCentricIcon} alt="Customer-centric Approach" />
              </div>
              <h3 className="feature-title">CUSTOMER-CENTRIC APPROACH</h3>
              <p className="feature-description">At Ampire Finance, our customer comes first, and customer satisfaction is what we aim to achieve.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values Section */}
      <section className="core-values">
        <div className="container">
          <h2 className="core-values-title">OUR CORE VALUES</h2>
          <div className="core-values-underline"></div>
          
          <div className="core-values-grid">
            <div className="core-value-item">
              <div className="core-value-icon">🤝</div>
              <h3 className="core-value-title">TRUST</h3>
            </div>
            
            <div className="core-value-item">
              <div className="core-value-icon">👁️</div>
              <h3 className="core-value-title">FOCUS</h3>
            </div>
            
            <div className="core-value-item">
              <div className="core-value-icon">🌐</div>
              <h3 className="core-value-title">INTEGRITY</h3>
            </div>
            
            <div className="core-value-item">
              <div className="core-value-icon">🏆</div>
              <h3 className="core-value-title">EXCELLENCE</h3>
            </div>
            
            <div className="core-value-item">
              <div className="core-value-icon">➡️➡️</div>
              <h3 className="core-value-title">CONSISTENCY</h3>
            </div>
            
            <div className="core-value-item">
              <div className="core-value-icon">👥</div>
              <h3 className="core-value-title">TEAM WORK</h3>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
